import { Component, Input, HostListener } from '@angular/core';
import { MainNavMenu } from '@frontend/unhideschool/app/utils/i18n/locale/main-nav/main-nav.i18n.model';
@Component({
  selector: 'unh-main-nav-container',
  styleUrls: ['./main-nav-container.component.scss'],
  templateUrl: './main-nav-container.component.html'
})
export class MainNavContainerComponent {
  @Input() navItemList: MainNavMenu[];
  @Input() isOpen: boolean;
  @Input() position: 'left' | 'right';
  @Input() hasWarning:boolean;
    matchMedia(rule: string) {
    const mq = window.matchMedia(rule);
    return mq.matches;
  }
  constructor(){
  }
}
